import React from "react";
import PageHero from "../components/PageHero";
import ContactSection from "../components/ContactSection";
import TestimonialsStrip from "../components/TestimonialsStrip";
import SEO from "../components/SEO";
import * as Icons from "lucide-react";
import {
  Mail,
  MapPin,
  Clock,
  Phone,
  Star,
  Instagram,
  Music2,
} from "lucide-react";
import {
  CONTACT_EMAIL,
  CONTACT_PHONE,
  CONTACT_LOCATION,
  TRUST_BADGES,
} from "../data/mock";

const InfoCard = ({ icon: Icon, label, value, href }) => {
  const Inner = (
    <>
      <div className="w-10 h-10 rounded-xl bg-white border border-black/5 flex items-center justify-center">
        <Icon size={18} className="text-pink-500" />
      </div>
      <div className="mt-4 text-xs uppercase tracking-[0.2em] font-semibold text-neutral-500">
        {label}
      </div>
      <div className="mt-1 font-display font-bold text-neutral-950">
        {value}
      </div>
    </>
  );
  const cls =
    "block p-6 rounded-2xl bg-neutral-50 border border-black/5 hover:border-pink-200 transition-colors";
  return href ? (
    <a href={href} className={cls}>
      {Inner}
    </a>
  ) : (
    <div className={cls}>{Inner}</div>
  );
};

const KontaktPage = () => {
  return (
    <>
      <SEO
        title="Kontakt – Kostenlose Beratung anfragen"
        description="Erzähl uns kurz von deinem Projekt. Kostenloses Erstgespräch, individuelle Analyse, Antwort innerhalb 24 Stunden. Unverbindlich."
        path="/kontakt"
        keywords="Kontakt Marketing Agentur, Erstgespräch, Beratung Social Media, Angebot einholen, Anfrage"
      />
      <PageHero
        eyebrow="Kontakt"
        title="Lass uns"
        gradient="loslegen."
        subtitle="Erzähl uns kurz von eurem Projekt. Wir melden uns innerhalb von 24 Stunden zurück – kostenlos und unverbindlich."
      />

      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <InfoCard
            icon={Mail}
            label="E-Mail"
            value={CONTACT_EMAIL}
            href={`mailto:${CONTACT_EMAIL}`}
          />
          <InfoCard
            icon={Phone}
            label="Telefon"
            value={CONTACT_PHONE}
            href={`tel:${CONTACT_PHONE.replace(/\s/g, "")}`}
          />
          <InfoCard icon={MapPin} label="Standort" value={CONTACT_LOCATION} />
          <InfoCard icon={Clock} label="Erreichbar" value="Mo – Fr, 9 – 18 Uhr" />
        </div>
      </section>

      <ContactSection extended={true} />

      <TestimonialsStrip max={2} eyebrow="Bevor du schreibst — was andere sagen" />

      {/* Trust elements */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {TRUST_BADGES.map((b, i) => {
              const Ico = Icons[b.icon] || Star;
              return (
                <div
                  key={i}
                  className="flex items-center gap-3 p-5 rounded-2xl bg-neutral-50 border border-black/5"
                >
                  <div className="shrink-0 w-10 h-10 rounded-xl bg-gradient-to-br from-pink-500 via-orange-500 to-purple-500 flex items-center justify-center">
                    <Ico size={18} className="text-white" />
                  </div>
                  <span className="text-sm font-semibold text-neutral-800">
                    {b.text}
                  </span>
                </div>
              );
            })}
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-neutral-600">
            <div className="flex items-center gap-2">
              <span className="text-sm">Folge uns:</span>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-neutral-100 hover:bg-gradient-to-br hover:from-pink-500 hover:via-orange-500 hover:to-purple-500 flex items-center justify-center hover:text-white transition-all"
              >
                <Instagram size={16} />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-neutral-100 hover:bg-gradient-to-br hover:from-pink-500 hover:via-orange-500 hover:to-purple-500 flex items-center justify-center hover:text-white transition-all"
              >
                <Music2 size={16} />
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KontaktPage;
